export function isNativeCloudPortalMode(targetWindow = typeof window !== "undefined" ? window : null) {
	if (!targetWindow) {
		return false;
	}

	const search = targetWindow.location && targetWindow.location.search ? targetWindow.location.search : "";
	const params = new URLSearchParams(search);
	const nativeCloudPortalValue = `${params.get("nativeCloudPortal") || ""}`.toLowerCase();
	const hasNativeWebViewBridge = !!(
		targetWindow.ReactNativeWebView &&
		typeof targetWindow.ReactNativeWebView.postMessage === "function"
	);

	return nativeCloudPortalValue === "1" || nativeCloudPortalValue === "true" || hasNativeWebViewBridge;
}
